"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
var VisibilityOff_1 = __importDefault(require("@mui/icons-material/VisibilityOff"));
var TextField_1 = __importDefault(require("../text-field/TextField"));
/**
 * @component PasswordField
 * @example
 * return (
 *   <PasswordField
 *     label="Password"
 *     name="password"
 *     type="password"
 *     value={formik.values.password}
 *     onChange={formik.handleChange}
 *     onBlur={formik.handleBlur}
 *     placeholder="Enter Your Password"
 *     helperText=""
 *   />
 * )
 *
 * @param {string} name name of the field;
 * @param {string | number | null} value the value of the field
 * @param {boolean} disabled is the field disabled?
 * @param {function} onChange what happens on change of the field
 * @param {function} onBlur what happens when the user focuses away from the field
 * @param { boolean | undefined} error error message
 * @param {boolean} required is this field required
 * @param {string} label descriptive label to display on the field
 * @param {boolean} select  boolean for whether or not this is a 'Select' dropdown instead of standard input
 * @param {string} placeholder placeholder string
 */
var PasswordField = function (props) {
    var _a = (0, react_1.useState)(false), showPassword = _a[0], setShowPassword = _a[1];
    var onClick = function () {
        setShowPassword(!showPassword);
    };
    var name = props.name, value = props.value, disabled = props.disabled, onChange = props.onChange, onBlur = props.onBlur, error = props.error, _b = props.required, required = _b === void 0 ? true : _b, label = props.label, _c = props.select, select = _c === void 0 ? false : _c, placeholder = props.placeholder;
    return (react_1.default.createElement(TextField_1.default, { disabled: disabled, name: name, value: value, type: showPassword ? "text" : "password", select: select, error: error, onChange: onChange, onBlur: onBlur, placeholder: placeholder, required: required, label: label, maxLength: 64, endAdornment: react_1.default.createElement(material_1.IconButton, { edge: "end", "aria-label": "Toggle password visibility", onClick: onClick }, showPassword ? react_1.default.createElement(VisibilityOff_1.default, null) : react_1.default.createElement(Visibility_1.default, null)) }));
};
exports.default = PasswordField;
